import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = ({ onNavigate }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      images: [
        '/elektrik1.jpeg',
        '/elektrik2.jpeg',
        '/elektrik3.jpeg'
      ],
      title: 'Profesyonel Elektrik Tesisatı',
      subtitle: 'Kalfa Elektrik Elektronik ile konut ve işyerleriniz için güvenli ve kaliteli elektrik tesisatı çözümleri sunuyoruz.'
    },
    {
      images: [
        '/elektrik4.jpeg',
        '/elektrik5.jpeg',
        '/elektrik6.jpeg'
      ],
      title: 'Elektronik Sistem Kurulumu',
      subtitle: 'Akıllı ev sistemleri, güvenlik sistemleri ve otomasyon çözümleri ile modern yaşam alanları oluşturuyoruz.'
    },
    {
      images: [
        '/elektrik7.jpeg',
        '/elektrik8.jpeg',
        '/elektrik9.jpeg'
      ],
      title: 'Bakım ve Onarım Hizmetleri',
      subtitle: '7/24 teknik destek ve bakım hizmetleri ile elektrik sistemlerinizin sürekli çalışır durumda kalmasını sağlıyoruz.'
    },
    {
      images: [
        '/elektrik10.jpeg',
        '/elektrik11.jpeg',
        '/elektrik12.jpeg'
      ],
      title: 'Endüstriyel Elektrik Çözümleri',
      subtitle: 'Fabrikalar ve endüstriyel tesisler için güçlü ve güvenilir elektrik sistemleri kuruyoruz.'
    },
    {
      images: [
        '/elektrik13.jpeg',
        '/elektrik14.jpeg',
        '/elektrik15.jpeg'
      ],
      title: 'Hizmetlerimizi görün',
      subtitle: 'Tost makinesi tamiri, TV tamiri, elektrik tesisatı ve daha fazlası. Tüm hizmetlerimizi inceleyin.',
      linkTo: 'services'
    },
    {
      images: [
        '/elektrik16.jpeg',
        '/elektrik17.jpeg',
        '/elektrik18.jpeg'
      ],
      title: 'Ürünlerimizi görün',
      subtitle: 'Elektrik ve elektronik ürünlerimizi keşfedin, teklif alın.',
      linkTo: 'products'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="hero-slide-collage">
              {slide.images.map((img, imgIndex) => (
                <div
                  key={imgIndex}
                  className="hero-collage-item"
                  style={{ backgroundImage: `url(${img})` }}
                ></div>
              ))}
            </div>
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <div className="hero-text">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
                {slide.linkTo && onNavigate && (
                  <button
                    type="button"
                    className="hero-cta-btn"
                    onClick={() => onNavigate(slide.linkTo)}
                  >
                    {slide.linkTo === 'services' ? 'Hizmetlerimiz' : 'Ürünlerimiz'}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="hero-arrow hero-arrow-left" onClick={goToPrevious} aria-label="Önceki">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <button className="hero-arrow hero-arrow-right" onClick={goToNext} aria-label="Sonraki">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <div className="hero-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
